import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
// Builds a program for a vertex/fragment shader
export function buildProgram(ctx, vertexSource, fragmentSource) {
  const program = ctx.createProgram();
  const vertexShader = ctx.createShader(ctx.VERTEX_SHADER);
  ctx.shaderSource(vertexShader, vertexSource);
  ctx.compileShader(vertexShader);
  const fragmentShader = ctx.createShader(ctx.FRAGMENT_SHADER);
  ctx.shaderSource(fragmentShader, fragmentSource);
  ctx.compileShader(fragmentShader);
  ctx.attachShader(program, vertexShader);
  ctx.attachShader(program, fragmentShader);
  ctx.linkProgram(program);
  return program;
}
export function initializePerspectiveTransformProgram(_ref) {
  let {
    ctx,
    program,
    width,
    height,
    document,
    matrixValues
  } = _ref;
  ctx.viewport(0, 0, width, height);
  const docLoc = ctx.getUniformLocation(program, "document");
  const matrixLoc = ctx.getUniformLocation(program, "matrix");
  const texSizeLoc = ctx.getUniformLocation(program, "texSize");
  ctx.uniform1i(docLoc, 3);
  ctx.activeTexture(ctx.TEXTURE3);
  ctx.bindTexture(ctx.TEXTURE_2D, document);
  ctx.uniformMatrix3fv(matrixLoc, false, new Float32Array(matrixValues));
  ctx.uniform2f(texSizeLoc, width, height);
  const resolutionLocation = ctx.getUniformLocation(program, "u_resolution");
  ctx.uniform2f(resolutionLocation, width, height);
  const positionLocation = ctx.getAttribLocation(program, "a_position");
  const vertexBuffer = ctx.createBuffer();
  ctx.bindBuffer(ctx.ARRAY_BUFFER, vertexBuffer);
  // Create two triangles that represent a plane with the input width and height
  ctx.bufferData(ctx.ARRAY_BUFFER, new Float32Array([0, 0, width, 0, 0, height, 0, height, width, 0, width, height]), ctx.STATIC_DRAW);
  ctx.enableVertexAttribArray(positionLocation);
  ctx.vertexAttribPointer(positionLocation, 2, ctx.FLOAT, false, 0, 0);
  const texCoordLocation = ctx.getAttribLocation(program, "a_texCoord");
  const fragmentBuffer = ctx.createBuffer();
  ctx.bindBuffer(ctx.ARRAY_BUFFER, fragmentBuffer);
  // Input UV coordinates for the two triangles that go from 0,0 - 1,1
  ctx.bufferData(ctx.ARRAY_BUFFER, new Float32Array([0.0, 0.0, 1.0, 0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0, 1.0]), ctx.STATIC_DRAW);
  ctx.enableVertexAttribArray(texCoordLocation);
  ctx.vertexAttribPointer(texCoordLocation, 2, ctx.FLOAT, false, 0, 0);
  return {
    vertexBuffer,
    fragmentBuffer
  };
}
export function flushProgram(ctx, vertexBuffer, fragmentBuffer) {
  ctx.deleteBuffer(vertexBuffer);
  ctx.deleteBuffer(fragmentBuffer);
}
// Creates and binds a texture to the context
export function bindTexture(ctx, canvas, filter) {
  const texture = ctx.createTexture();
  ctx.bindTexture(ctx.TEXTURE_2D, texture);
  ctx.texParameteri(ctx.TEXTURE_2D, ctx.TEXTURE_WRAP_S, ctx.CLAMP_TO_EDGE);
  ctx.texParameteri(ctx.TEXTURE_2D, ctx.TEXTURE_WRAP_T, ctx.CLAMP_TO_EDGE);
  if (canvas) {
    ctx.texImage2D(ctx.TEXTURE_2D, 0, ctx.RGBA, ctx.RGBA, ctx.UNSIGNED_BYTE, canvas);
  }
  ctx.texParameteri(ctx.TEXTURE_2D, ctx.TEXTURE_MIN_FILTER, filter);
  ctx.texParameteri(ctx.TEXTURE_2D, ctx.TEXTURE_MAG_FILTER, filter);
  return texture;
}
export function executeShader(ctx) {
  // Draw the 6 points from two triangles
  ctx.drawArrays(ctx.TRIANGLES, 0, 6);
}